import * as React from 'react';

function SvgIconTitlePlaceholder(props) {
  return (
    <svg width={208} height={88} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#D9D9D9" d="M16 18h85v8H16z" />
      <path fill="#E8E8E8" d="M16 38h176v2H16zm0 10h176v2H16zm0 10h176v2H16zm0 10h176v2H16z" />
    </svg>
  );
}

export default SvgIconTitlePlaceholder;
